var $52731caf9b0efb5b$exports = {};
$52731caf9b0efb5b$exports = {
    "collectionLabel": `Prijedlozi`
};


export {$52731caf9b0efb5b$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
